import { render } from "./SocketsManager.vue?vue&type=template&id=69ccbc21&ts=true"
import script from "./SocketsManager.vue?vue&type=script&lang=ts"
export * from "./SocketsManager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__